// @ts-nocheck
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { URL } from '../../service/Service';


const CashPayment = ({
                         value,
                         formReplies,
                         fixedValue,
                         itemPurchases,
                         donations
                     }) => {

    const [error, setError] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const navigate = useNavigate();


    const paymentErrorMessage =
        'Não foi possível concluir o pedido. Por favor, tente novamente.';


    const handleFetch = async () => {

        if (
            isSubmitting
            || !isChecked
        ) {
            return;
        }


        setIsSubmitting(true);
        setError('');


        try {

            const body = {

                value,

                fixedValue,

                itemPurchases,

                donations,

                formID: formReplies.formID,

                replyFields: formReplies.replyFields,

                /*
                 * IP público obtido no FormReader.
                 */
                ip: formReplies?.ip || ''

            };


            const response = await fetch(
                `${URL}/api/payment/cashpayment`,
                {
                    method: 'POST',

                    headers: {
                        accept: 'application/json',
                        'content-type': 'application/json'
                    },

                    body: JSON.stringify(body)
                }
            );


            const responseText =
                await response.text();


            /*
             * Não mostrar diretamente ao cliente
             * mensagens técnicas devolvidas pelo backend.
             */
            if (!response.ok) {

                setError(
                    paymentErrorMessage
                );

                return;
            }


            let parsedResult = {};


            if (responseText) {

                try {

                    parsedResult =
                        JSON.parse(responseText);

                } catch (_error) {

                    setError(
                        paymentErrorMessage
                    );

                    return;
                }
            }


            navigate(
                '/clientforms/success/cashpayment',
                {
                    state: {
                        paymentinfo: parsedResult,
                        formId: formReplies.formID
                    }
                }
            );


        } catch (_error) {

            setError(
                paymentErrorMessage
            );

        } finally {

            setIsSubmitting(false);

        }
    };


    const handleSubmit = async (event) => {

        event.preventDefault();

        await handleFetch();

    };


    return (

        <div className="mt-5">


            {/* ===================================================
                CONSENTIMENTO
                =================================================== */}
            <label
                htmlFor="cashpayment-consent"

                className="
                    mt-6
                    flex
                    cursor-pointer
                    items-start
                    gap-3
                    rounded-xl
                    border
                    p-4
                    text-sm
                "

                style={{
                    color: 'var(--form-text)',
                    borderColor: 'var(--form-border)',
                    background: 'var(--form-surface)'
                }}
            >

                <input
                    id="cashpayment-consent"

                    type="checkbox"

                    checked={isChecked}

                    disabled={isSubmitting}

                    onChange={(event) => {

                        setIsChecked(
                            event.target.checked
                        );

                        if (error) {
                            setError('');
                        }

                    }}

                    className="
                        mt-0.5
                        h-4
                        w-4
                        shrink-0
                        rounded
                        border-gray-300
                        text-green-cl
                        focus:ring-green-cl
                        disabled:cursor-not-allowed
                        disabled:opacity-60
                    "

                    style={{
                        accentColor: 'var(--form-primary)'
                    }}
                />


                <span
                    className="leading-relaxed"
                    style={{
                        color: 'var(--form-text)'
                    }}
                >
                    Tomei conhecimento que a informação constante deste formulário é guardada e tratada pela Eupago e dou consentimento para tal.
                </span>

            </label>


            {/* ===================================================
                ERRO
                =================================================== */}
            {error && (

                <div
                    role="alert"

                    className="
                        mt-4
                        rounded-xl
                        border
                        border-red-200
                        bg-red-50
                        p-4
                    "
                >

                    <p
                        className="
                            text-sm
                            font-semibold
                            text-red-700
                        "
                    >
                        {error}
                    </p>

                </div>

            )}


            {/* ===================================================
                FINALIZAR
                =================================================== */}
            <div className="flex justify-end">

                <button
                    type="button"

                    onClick={handleSubmit}

                    disabled={
                        !isChecked
                        || isSubmitting
                    }

                    className="
                        mt-6
                        inline-flex
                        w-full
                        items-center
                        justify-center
                        rounded-xl
                        bg-green-cl
                        px-5
                        py-3
                        font-semibold
                        text-white
                        transition
                        hover:bg-opacity-90
                        disabled:cursor-not-allowed
                        disabled:opacity-50
                    "
                >

                    {
                        isSubmitting
                            ? 'A processar...'
                            : 'Finalizar'
                    }

                </button>

            </div>

        </div>
    );
};


export default CashPayment;